import * as React from 'react';

import { ReviewsSection, IReview } from 'shared/components/ReviewsSection';
import { useCarousel } from 'shared/hooks';

import ChevronRightG from 'shared/components/ReviewsSection/assets/ChevronRightG.svg';

const REVIEWS: IReview[] = [
  {
    author: 'Игорь О.',
    subtitle: 'продажа квартиры',
    date: '17 января',
    text: 'Четко и грамотно рассказал про все этапы; сообщал о всех просмотрах, о претензиях покупателей; вообще молодец.  Я вообще не занимался продажей, всё он сам сделал, он сам показывал и договаривался о показах, я только приехал на сделку.',
  },
  {
    author: 'Ирина У.',
    subtitle: 'продажа и покупка',
    date: '3 ноября 2025',
    text: 'Очень хороший риелтор, здорово помогла. Очень квалифицированный специалист, без воды, всё четко, контролировала весь процесс. Всегда отзывчива, любой вопрос решается быстро, обязательно подключает юристов, обоснования делает всегда, если у меня какие-то непонимания идут. Я оставила отзыв им на сайте, и вам благодарна, что вы меня познакомили с таким замечательным риелтором',
  },
  {
    author: 'Анна Р.',
    subtitle: 'продажа квартиры',
    date: '28 октября 2025',
    text: 'Вообще все было хорошо, и в качестве как она рекламу квартире сделала, фотографии отфоткала самостоятельно ,проводила сделку и переговоры, я вообще нигде не участвовала я пришла только на сделку и на показы приходила,мне очень понравилось.',
  },
  {
    author: 'Пётр С.',
    subtitle: 'продажа квартиры',
    date: '15 сентября 2025',
    text: 'Понравилось то, что давала советы,при оформлении каких-то моментов,например снятие с регистрации с учета вот такие вещи, которые мы  не знали, чтоб ускорить процесс ,способствовала нам , чтобы сделка прошла очень быстро,нюансы советы заблаговременно нас предупреждала, справилась с нашей задачей, все нам понравилось.',
  },
  {
    author: 'София Г.',
    subtitle: 'продажа квартиры',
    date: '7 августа 2025 ',
    text: 'Продавала не я, я просто присутствовала, риелтор очень организованная, четкая, все наши пожелания нюансы принимала во внимание, я помогала подруге продать квартиру в сжатые сроки,  очень хорошо вошла в тему и все сделала так, как можно было сделать лучшим образом в данных обстоятельствах, очень довольны остались , мы работали с Ириной ,Наталья куратор.',
  },
  {
    author: 'Лидия Н.',
    subtitle: 'продажа квартиры',
    date: '6 августа 2025',
    text: 'Полностью удовлетворена его работай, всё прошло отлично. Михаила однозначно буду рекомендовать, всё сделал за меня, полностью помог с продажей, с документами, с бесконечными справками и еще кучей всего. И если встанет вопрос покупки, то обратимся к нему.',
  },
  {
    author: 'Николай И.',
    subtitle: 'продажа квартиры',
    date: '1 июня 2025',
    text: 'её профессионализм,  у нас была тяжелая, сложная сделка, и она сама ездила к нотариусу, всё узнавала, консультировалась с юристами, подошла к вопросу очень ответственно и профессионально. буду всем рекомендовать её',
  },
];

export const ReviewsSectionContainer: React.FC = () => {
  const rootRef = React.useRef<HTMLDivElement>(null);
  const trackRef = React.useRef<HTMLDivElement>(null);
  const prevButtonRef = React.useRef<HTMLButtonElement>(null);
  const nextButtonRef = React.useRef<HTMLButtonElement>(null);

  const { stepBy } = useCarousel({
    rootRef,
    trackRef,
    prevButtonRef,
    nextButtonRef,
    cardCount: REVIEWS.length,
  });

  return (
    <ReviewsSection
      reviews={REVIEWS}
      rootRef={rootRef}
      trackRef={trackRef}
      prevButtonRef={prevButtonRef}
      nextButtonRef={nextButtonRef}
      onPrevClick={() => stepBy(-1)}
      onNextClick={() => stepBy(1)}
      arrowIcon={ChevronRightG}
    />
  );
};
